import { Link } from "react-router-dom";
import Carregando from "../componentes/Carregando";
import Rodape from "../componentes/Rodape";
import { useHub } from "../lib/dados";
import { POS_GRADUACAO, type Pos } from "../lib/areas";
import { Aviso, SetaDireita, Topo } from "../componentes/ui";

// A página `pos-graduacao` do app do Bubble: o seletor das 7 pós-graduações da FBC
// (N11, fase 2). Mostra as 7 SEMPRE, como no Bubble; a que o aluno tem leva ao
// curso, a que não tem fica "Sem acesso". A secretaria, as notas e o boletim são
// compartilhados e seguem na Faculdade (link ao pé).
//
// Com a cara do Bubble (29/10): o fundo branco com a marca d'água do CF, a saudação
// e os 7 cards como as imagens do Bubble, 3 na primeira linha e 4 na segunda. As
// artes saíram do pacote PÚBLICO da página (o `static_js` de `/live/pos-graduacao/`,
// sem login), como as das páginas de curso. Lá cada pós tem a mesma arte duas
// vezes: inteira para quem tem acesso e com opacidade 0,5 para quem não tem. Aqui
// a arte é uma só, e a opacidade vem da tela; o "Sem acesso" fica escrito no chip,
// por cima, porque a arte esmaecida sozinha não diz o motivo.
export default function PosGraduacao() {
  const estado = useHub();
  if (estado.fase === "carregando") return <Carregando />;
  if (estado.fase === "erro") {
    return (
      <Aviso titulo="Algo deu errado">
        Não conseguimos carregar as pós-graduações agora. Recarregue a página; se continuar assim,
        fale com o suporte.
      </Aviso>
    );
  }

  const hub = estado.fase === "pronto" ? estado.hub : null;
  const slugs = new Set((hub ? [...hub.cursos, ...hub.faculdade] : []).map((c) => c.slug));
  const temAlguma = POS_GRADUACAO.some((p) => slugs.has(p.slug));
  // As duas linhas do Bubble: 3 em cima e 4 embaixo, centralizadas.
  const linhas = [POS_GRADUACAO.slice(0, 3), POS_GRADUACAO.slice(3)];

  return (
    <div
      className="min-h-screen"
      // A marca d'água do CF sobre branco, como no Bubble (center/cover/fixed).
      style={{ background: "#ffffff url('/fundo-cf.png') center center / cover no-repeat fixed" }}
    >
      <Topo atual="inicio" nome={hub?.nome ?? null} avatarUrl={hub?.avatarUrl} />

      {/* Com o fundo branco fixo, o conteúdo é território claro (`tema-claro`, no
          index.css), como na página de curso com card-imagem. O Topo fica fora. */}
      <div className="tema-claro mx-auto max-w-6xl px-4 pb-16 sm:px-6">
        <Link
          to="/"
          className="mt-6 mb-4 inline-flex items-center gap-2 text-sm font-semibold text-cinza transition hover:text-titulo"
        >
          <SetaDireita className="size-4 rotate-180" /> Voltar ao início
        </Link>

        <div className="rise text-center">
          <h1 className="text-2xl font-bold text-[#0b1e42] sm:text-3xl">
            Seja bem-vindo(a) à Área da Pós-Graduação!
          </h1>
          <p className="mt-2 font-semibold text-[#0b1e42]">Selecione qual dos cursos deseja acessar:</p>
        </div>

        <div className="mt-8 flex flex-col gap-4">
          {linhas.map((linha, l) => (
            <div key={l} className="flex flex-wrap justify-center gap-4">
              {linha.map((pos, i) => (
                <CardDaPos key={pos.slug} pos={pos} temAcesso={slugs.has(pos.slug)} i={l * 3 + i + 1} />
              ))}
            </div>
          ))}
        </div>

        {/* Secretaria, notas e boletim são compartilhados e moram na Faculdade. */}
        {temAlguma && (
          <div className="mt-8">
            <Link to="/faculdade" className="inline-flex items-center gap-2 font-bold text-link">
              Secretaria, notas e boletim
              <span className="text-laranja-texto">
                <SetaDireita />
              </span>
            </Link>
          </div>
        )}

        <Rodape />
      </div>
    </div>
  );
}

function CardDaPos({ pos, temAcesso, i }: { pos: Pos; temAcesso: boolean; i: number }) {
  // Quatro por linha no computador e dois no tablet; a linha de 3 fica centralizada.
  // O teto de 381px é a largura da arte: acima dele a imagem só borraria.
  const largura = "w-full max-w-[381px] sm:w-[calc((100%-1rem)/2)] lg:w-[calc((100%-3rem)/4)]";
  const estilo = { "--i": i } as React.CSSProperties;
  const imagem = (
    <img
      src={`/cards/pos-graduacao/${pos.slug}.png`}
      alt={pos.nome}
      loading="lazy"
      className={`block w-full rounded-2xl${temAcesso ? "" : " opacity-50"}`}
    />
  );

  if (!temAcesso) {
    return (
      <div className={`rise relative ${largura}`} style={estilo}>
        {imagem}
        <span className="absolute right-3 top-3 inline-flex items-center rounded-full bg-chip px-2.5 py-0.5 text-xs font-semibold text-chip-tinta">
          Sem acesso
        </span>
      </div>
    );
  }
  return (
    <Link
      to={`/curso/${pos.slug}`}
      className={`porta rise relative block overflow-hidden rounded-2xl ${largura}`}
      style={estilo}
    >
      {imagem}
    </Link>
  );
}
